import React, { useContext, useEffect, useState } from 'react'
import PageWrapper from '../layout/PageWrapper/PageWrapper'
import Page from '../layout/Page/Page'
import { useFormik } from 'formik'
import AuthContext from '../contexts/authContext'
import { TableLoader, showLoader } from '../services/loader.services'
import NoDataMsg from '../common/components/NoDataMsg'
import useSortableData from '../hooks/useSortableData'
import { toasts } from '../services/toaste.service'
import { getLicenseKey } from '../services/application.settings'
import AlertService from '../services/alert.service'
import { updateDeliveryChallanDetails, getDeliveryChallanDetails } from '../services/productService'
import PaginationButtons, { dataPagination } from './PaginationButtons'
import Button, { ButtonGroup } from './bootstrap/Button'
import Card, { CardHeader, CardLabel, CardTitle, CardActions, CardBody, CardSubTitle } from './bootstrap/Card'
import FormGroup from './bootstrap/forms/FormGroup'
import Modal, { ModalHeader, ModalTitle, ModalBody, ModalFooter } from './bootstrap/Modal'
import Icon from './icon/Icon'
import Input from './bootstrap/forms/Input'
import { getCompanyDetails, getCurrentDateAndTime, getHsnCode, onlyAllowNumber } from '../services/common.service'
import SearchableSelect from '../common/components/SearchableSelect'
import InputGroup, { InputGroupText } from './bootstrap/forms/InputGroup'
import Textarea from './bootstrap/forms/Textarea'
import { useNavigate } from 'react-router-dom'

const AddChallanDetails = () => {

    useEffect(() => {
        getDeliveryChallan()
        getHsnCodeList()
    }, [])

    const challanDetailsForm = useFormik({
        enableReinitialize: true,
        validateOnMount: true,
        initialValues: {
            challanDate: getCurrentDateAndTime('date'),
            placeOfSupply: '',
            weavingProcess: ''
        },
        validate: (values: any) => {
            const errors: any = {};
            if (!values.challanDate) {
                errors.challanDate = 'Required';
            }
            if (!companyDetailsId || !companyDetailsId.value) {
                errors.placeOfSupply = 'Required';
            }

            inputList.forEach((item: any, index: number) => {
                if (!item.hsnCode) {
                    errors[`hsnCode_${index}`] = 'Required';
                }
                if (!item.productRate) {
                    errors[`productRate_${index}`] = 'Required';
                }
                if (!item.cgstRate) {
                    errors[`cgstRate_${index}`] = 'Required';
                }
                if (!item.sgstRate) {
                    errors[`sgstRate_${index}`] = 'Required';
                }
            });

            return errors;
        },
        //validateOnChange: false,
        onSubmit: () => { addDispatchProductSubmit() },
    });

    const columnVisibileForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { },
    });

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [deliveryChallanDetailsData, setDeliveryChallanDetailsData] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState('')

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(deliveryChallanDetailsData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [dataStatus, setDataStatus] = useState(false)

    const [isOpen, setIsOpen] = useState(false);
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });

    // Filter
    const filteredData = onCurrentPageData.filter((i) =>
        (i.challanNo && i.challanNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
        (i.challanDateForView && i.challanDateForView.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
        (i.companyName && i.companyName.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
        (i.truckNo && i.truckNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())),
    );

    const [noOfBags, setNoOfBags] = useState<any>('');
    const [quantity, setQuantity] = useState<any>('');
    const [totalAmount, setTotalAmount] = useState<any>('');
    const [cgstAmount, setCgstAmount] = useState<any>('');
    const [sgstAmount, setSgstAmount] = useState<any>('');
    const [finalAmount, setFinalAmount] = useState<any>('');
    const [companyDetailsId, setCompanyDetailsId] = useState<any>('');
    const [weavingProcess, setWeavingProcess] = useState<any>('');

    function setDeliveryChallanDetails() {
        return ({
            licenseKey: getLicenseKey,
            supplyCompanyId: companyDetailsId?.value,
            processType: weavingProcess,
            userAccountId: userAccountId,
            deliveryChallanDetails: dispatchDetails.map((item: any) => ({
                deliveryChallanDetailsId: item.deliveryChallanDetailsId,
                hsnCode: item.hsnCode,
                noOfBags: item.noOfBags,
                netWeight: item.quantity,
                bagRate: item.productRate,
                totalAmount: item.totalAmount,
                cgstPercentage: item.cgstRate,
                cgstAmount: item.cgstAmount,
                sgstPercentage: item.sgstRate,
                sgstAmount: item.sgstAmount,
                finalAmount: item.finalAmount
            }))
        })
    }

    function addDispatchProductSubmit() {
        showLoader(true)
        let challanPostData = setDeliveryChallanDetails()
        if (dispatchDetails.length > 0) {
            if (challanDetailsForm.isValid) {
                updateDeliveryChallanDetails(challanPostData,
                    (response) => {
                        const data = response.data;
                        if (data.success == true) {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "success" });
                            setIsOpen(true);
                            closeAndReset()
                        }
                        else if (data.success == false) {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "error" });
                            setIsOpen(true);
                        }
                        else {
                            let errorCode = response.data.error[0].error_code;
                            let errorDescription = response.data.error[0].error_description;
                            showLoader(false)
                            setAlertStatus({ message: errorDescription, type: "error" });
                            setIsOpen(true);
                        }
                    }
                    , (error) => {
                        showLoader(false)
                        setAlertStatus({ message: error, type: "error" });
                        setIsOpen(true);
                    }
                )
            } else if (challanDetailsForm.isValid == false) {
                toasts("Please fill all details", "Error");
            }
        }
        else {
            toasts("Please Enter Dispatch Details", "Error");
        }
    }

    function getDeliveryChallan() {
        getDeliveryChallanDetails(
            (response) => {
                if (response.data.success) {
                    let rawData = response.data.data.deliveryChallanItems;
                    if (rawData != undefined) {
                        setDataStatus(true)
                        let mappedData = rawData.map((item: any, index: number) => ({
                            ...item,
                            sno: index + 1,
                            deliveryChallanId: item.challanUniqueNo,
                            truckNo: item.vehicleNo,
                            placeOfSupply: item.supplyCompanyId,
                            companyNameForPlaceOfSupply: item.supplyCompanyName,
                            productDetails: (item.deliveryChallanItems || []).map((p: any) => ({
                                ...p,
                                quantity: p.netWeight,
                                productRate: p.bagRate,
                                cgstRate: p.cgstPercentage,
                                sgstRate: p.sgstPercentage
                            }))
                        }));
                        setDeliveryChallanDetailsData(mappedData)

                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    const [hsnCodeData, setHsnCodeData] = useState<any>([]);

    function getHsnCodeList() {
        getHsnCode(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.hsnCode;
                    if (data != undefined) {
                        setHsnCodeData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setHsnCodeData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    const [companyDetailsData, setCompanyDetailsData] = useState<any>([]);

    function getCompanyList() {
        getCompanyDetails(0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.companyDetails;
                    if (data != undefined) {
                        setCompanyDetailsData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setCompanyDetailsData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function closeAndReset() {
        challanDetailsForm.resetForm()
        getDeliveryChallan()
        setAssignCompanyToCone(false)
        setIsOpenModal(false)
        setInputList([])
    }

    const [assignCompanyToCone, setAssignCompanyToCone] = useState(false)
    const [dispatchDetails, setDispatchDetails] = useState<any>([])
    const [inputList, setInputList] = useState<any>([])
    const [count, setCount] = useState<any>(2)

    function handleInputChange(hsnCode: any, noOfBags: any, quantity: any, productRate: any, cgstRate: any, cgstAmount: any, sgstRate: any, sgstAmount: any, index: any, deliveryChallanDetailsId: any, isAdd: any, weavingProcess: any) {

        const list = [...inputList];

        const _noOfBags: any = noOfBags || '';
        const _quantity: any = quantity || '';
        const _rate: any = productRate || '';
        const _cgstRate: any = cgstRate || '2.5';
        const _sgstRate: any = sgstRate || '2.5';

        list[index]["isAdd"] = isAdd;

        if (isAdd == true && !hsnCode) {
            list[index]["hsnCode"] = "";
        } else {
            list[index]["hsnCode"] = hsnCode;
        }

        list[index]["deliveryChallanDetailsId"] = deliveryChallanDetailsId;
        list[index]["noOfBags"] = _noOfBags;
        list[index]["quantity"] = _quantity;
        list[index]["productRate"] = _rate;

        // ✔ total amount (without GST)
        const totalAmount = _quantity * _rate;
        list[index]["totalAmount"] = totalAmount.toFixed(2);

        // ✔ GST amounts
        const cgstAmt = (totalAmount * _cgstRate) / 100;
        const sgstAmt = (totalAmount * _sgstRate) / 100;

        list[index]["cgstRate"] = _cgstRate;
        list[index]["cgstAmount"] = cgstAmt.toFixed(2);

        list[index]["sgstRate"] = _sgstRate;
        list[index]["sgstAmount"] = sgstAmt.toFixed(2);

        // ✔ Final amount (with GST)
        list[index]["finalAmount"] = (totalAmount + cgstAmt + sgstAmt).toFixed(2);

        setInputList(list);
        setDispatchDetails(list);

        const totalNoOfBags = list.reduce((s: any, r: any) => s + Number(r.noOfBags || 0), 0);
        const totalQuantity = list.reduce((s: any, r: any) => s + Number(r.quantity || 0), 0);
        const totalProductAmount = list.reduce((s: any, r: any) => s + Number(r.totalAmount || 0), 0);
        const totalCgstAmount = list.reduce((s: any, r: any) => s + Number(r.cgstAmount || 0), 0);
        const totalSgstAmount = list.reduce((s: any, r: any) => s + Number(r.sgstAmount || 0), 0);
        const finalProductAmount = list.reduce((s: any, r: any) => s + Number(r.finalAmount || 0), 0);

        setNoOfBags(totalNoOfBags);
        setQuantity(totalQuantity);
        setTotalAmount(totalProductAmount.toFixed(2));
        setCgstAmount(totalCgstAmount.toFixed(2));
        setSgstAmount(totalSgstAmount.toFixed(2));
        setFinalAmount(finalProductAmount.toFixed(2));

        setTimeout(() => {
            challanDetailsForm.validateForm();
        }, 100);
    }

    function openModal() {
        setIsOpenModal(true)
        setInputList([...inputList, { displayOrder: 1, productData: [] }])
    }

    const [isOpenModal, setIsOpenModal] = useState(false);

    function onPrint(i: any) {
        if (i != undefined) {
            let selectedData = i
            window.open(selectedData.pdfPath);
        }
    }

    const [dcDetails, setDcDetails] = useState<any>([]);

    function onActivate(data: any) {
        getCompanyList()
        setIsOpenModal(true)
        setDcDetails(data)
        setWeavingProcess(data.processType)
        setCompanyDetailsId(data.placeOfSupply > 0 ? { value: data.placeOfSupply, label: data.companyNameForPlaceOfSupply } : '')
        challanDetailsForm.setValues({
            challanDate: data.challanDate,
            placeOfSupply: data.placeOfSupply,
            weavingProcess: data.processType
        })
        let productDetails = data?.productDetails;
        for (let i = 0; i < productDetails.length; i++) {
            productDetails[i].isAdd = hsnCodeData?.length > 0 ? false : true
        }

        const totalNoOfBags = productDetails.reduce((s: any, r: any) => s + Number(r.noOfBags || 0), 0);
        const totalQuantity = productDetails.reduce((s: any, r: any) => s + Number(r.quantity || 0), 0);
        const totalProductAmount = productDetails.reduce((s: any, r: any) => s + Number(r.totalAmount || 0), 0);
        const totalCgstAmount = productDetails.reduce((s: any, r: any) => s + Number(r.cgstAmount || 0), 0);
        const totalSgstAmount = productDetails.reduce((s: any, r: any) => s + Number(r.sgstAmount || 0), 0);
        const finalProductAmount = productDetails.reduce((s: any, r: any) => s + Number(r.finalAmount || 0), 0);

        setNoOfBags(totalNoOfBags)
        setQuantity(totalQuantity)
        setTotalAmount(totalProductAmount)
        setCgstAmount(totalCgstAmount)
        setSgstAmount(totalSgstAmount)
        setFinalAmount(finalProductAmount)

        setInputList(productDetails)
        setDispatchDetails(productDetails)
    }

    const navigate = useNavigate();

    function addInvoice(data: any) {
        navigate(`../addInvoice/${data.deliveryChallanId}`);
    }

    return (
        <PageWrapper title={`Add Delivery Challan`}>
            <Page>
                <Card stretch data-tour='list'>
                    <CardHeader borderSize={1}>
                        <CardLabel icon='List' iconColor='info' className="col-lg-7">
                            <CardTitle tag='div' className='h5'>Add Delivery Challan</CardTitle>
                        </CardLabel>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <ButtonGroup className="col-lg-3 d-print-none" color='primary'>
                            <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                            <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibileForm.handleChange} value={columnVisibileForm.values.searchInput} />
                        </ButtonGroup>
                    </CardHeader>
                    <CardBody>
                        {!dataStatus ?
                            <TableLoader /> :
                            <div className="table-responsive">
                                <table className='table table-modern table-hover small'>
                                    <thead className='table-primary'>
                                        <tr>
                                            <th scope='col' onClick={() => requestSort('sno')} className='cursor-pointer py-3 border-bottom-0 bg-light rounded-start'>
                                                <span className='small text-uppercase fw-bold'>S.No</span>
                                                <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('challanNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Challan No</span>
                                                <Icon size='lg' className={getClassNamesFor('challanNo')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('challanDateForView')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Challan Date</span>
                                                <Icon size='lg' className={getClassNamesFor('challanDateForView')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('companyName')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Company Name</span>
                                                <Icon size='lg' className={getClassNamesFor('companyName')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('truckNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Truck No</span>
                                                <Icon size='lg' className={getClassNamesFor('truckNo')} icon='FilterList' />
                                            </th>
                                            <th className='py-3 border-bottom-0 bg-light rounded-end'>
                                                <span className='small text-uppercase fw-bold'>Action</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    {deliveryChallanDetailsData != "" ? <>
                                        {filteredData.map((item: any) => (
                                            <tbody key={item.deliveryChallanId} className='border-top-0'>
                                                <tr className='shadow-hover-sm transition-base'>
                                                    <td className='py-3 fw-semibold text-muted'>{item.sno}</td>
                                                    <td className='py-3 text-dark'>{item.challanNo}</td>
                                                    <td className='py-3'>{item.challanDateForView}</td>
                                                    <td className='py-3'>{item.companyName}</td>
                                                    <td className='py-3'>{item.truckNo}</td>
                                                    <td className="py-3 d-print-none">
                                                        <Button
                                                            color='primary'
                                                            isLight
                                                            icon='Edit'
                                                            className='rounded-pill shadow-sm'
                                                            aria-label='Edit'
                                                            onClick={() => onActivate(item)}
                                                        />
                                                        {item.pdfPath != null ?
                                                            <Button
                                                                className="ms-2 rounded-pill shadow-sm"
                                                                color='success'
                                                                isLight
                                                                icon='Download'
                                                                aria-label='Download'
                                                                onClick={() => onPrint(item)}
                                                            /> : null
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ))} </> : <NoDataMsg columnsCount={10} msg={noDataMsg} />}
                                </table>
                            </div>
                        }
                    </CardBody>
                    <PaginationButtons className="d-print-none" data={items} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
                </Card>

                <Modal
                    setIsOpen={closeAndReset}
                    isOpen={isOpenModal}
                    titleId='edit'
                    isStaticBackdrop
                    // fullScreen
                    size='xl'>
                    <ModalHeader setIsOpen={closeAndReset}>
                        <ModalTitle id='examplemailcontent'>
                            <div className="h4">Add DC</div>
                        </ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <div className='row g-4'>
                            <div className="col-lg-6">
                                <div className="row g-3">
                                    <div className='col-lg-6'>
                                        <FormGroup id='companyName' label='Company Name' isFloating>
                                            <Input value={dcDetails?.companyName || ''} disabled />
                                        </FormGroup>
                                    </div>
                                    <div className='col-lg-6'>
                                        <FormGroup id='placeOfSupply' label='Place of Supply' isFloating>
                                            <SearchableSelect
                                                isFloating
                                                ariaLabel='placeOfSupply'
                                                onChange={(e: any) => setCompanyDetailsId(e)}
                                                value={companyDetailsId}
                                                onBlur={() => challanDetailsForm.setFieldTouched('placeOfSupply', true)}
                                                isValid={challanDetailsForm.touched.placeOfSupply ? !challanDetailsForm.errors.placeOfSupply : undefined}
                                                isTouched={challanDetailsForm.touched.placeOfSupply}
                                                invalidFeedback={challanDetailsForm.errors.placeOfSupply as string}
                                                list={companyDetailsData.map((data: any) => ({
                                                    value: data.companyDetailsId,
                                                    label: data.companyNameAndCityName,
                                                }))}
                                                required
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className='col-lg-4'>
                                        <FormGroup id='challanNo' label='Challan No' isFloating>
                                            <Input value={dcDetails?.challanNo || ''} disabled />
                                        </FormGroup>
                                    </div>
                                    <div className='col-lg-4'>
                                        <FormGroup id='challanDate' label='Challan Date' isFloating>
                                            <Input value={dcDetails?.challanDateForView || ''} disabled />
                                        </FormGroup>
                                    </div>
                                    <div className='col-lg-4'>
                                        <FormGroup id='truckNo' label='Truck No' isFloating>
                                            <Input value={dcDetails?.truckNo || ''} disabled />
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <FormGroup id='weavingProcess' label='Process Type' isFloating>
                                    <Textarea
                                        style={{ minHeight: 110 }}
                                        onChange={(e: any) => setWeavingProcess(e.target.value)}
                                        value={weavingProcess || ''}
                                        placeholder="Enter Process Type" />
                                </FormGroup>
                            </div>
                            <div className="row g-2">
                                {inputList.map((x: any, index: any) => (
                                    <div className='col-lg-6' key={index}>
                                        <Card stretch shadow={'md'} className="border border-light rounded-1">
                                            <CardHeader>
                                                <CardLabel>
                                                    <CardTitle tag='h6' className='text-muted'>{x.countNo}</CardTitle>
                                                </CardLabel>
                                                <CardActions>
                                                    <CardTitle tag='h6'>Lot No - <span className="text-primary">{x.lotNo}</span></CardTitle>
                                                </CardActions>
                                            </CardHeader>
                                            <CardBody>
                                                <div className='row g-4'>
                                                    <div className="col-lg-6">
                                                        <InputGroup>
                                                            {x.isAdd == false ?
                                                                <FormGroup id='hsnCode' label='HSN Code' isFloating>
                                                                    <SearchableSelect
                                                                        isFloating
                                                                        ariaLabel='hsnCode'
                                                                        onChange={(e: any) => handleInputChange(e?.value || '', x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                        value={x.hsnCode ? { value: x.hsnCode, label: x.hsnCode } : null}
                                                                        list={hsnCodeData.map((data: any) => ({
                                                                            value: data.hsnCode,
                                                                            label: data.hsnCode,
                                                                        }))}
                                                                        onBlur={() => challanDetailsForm.setFieldTouched(`hsnCode_${index}`, true)}
                                                                        isValid={(challanDetailsForm.touched as any)[`hsnCode_${index}`] ? !(challanDetailsForm.errors as any)[`hsnCode_${index}`] : undefined}
                                                                        isTouched={(challanDetailsForm.touched as any)[`hsnCode_${index}`]}
                                                                        invalidFeedback={(challanDetailsForm.errors as any)[`hsnCode_${index}`] as string}
                                                                        required
                                                                    />
                                                                </FormGroup> :
                                                                <FormGroup id='hsnCode' label='HSN Code' isFloating>
                                                                    <Input
                                                                        onChange={(e: any) => handleInputChange(e.target.value, x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                        value={x.hsnCode || ''}
                                                                        onBlur={() => challanDetailsForm.setFieldTouched(`hsnCode_${index}`, true)}
                                                                        isValid={(challanDetailsForm.touched as any)[`hsnCode_${index}`] ? !(challanDetailsForm.errors as any)[`hsnCode_${index}`] : undefined}
                                                                        isTouched={(challanDetailsForm.touched as any)[`hsnCode_${index}`]}
                                                                        invalidFeedback={(challanDetailsForm.errors as any)[`hsnCode_${index}`] as string}
                                                                        placeholder="Enter HSN Code" />
                                                                </FormGroup>
                                                            }
                                                            <Button
                                                                isOutline
                                                                icon='Add'
                                                                color='primary'
                                                                style={{ height: '46px' }}
                                                                onClick={(e: any) => handleInputChange(e.target.value, x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, !x.isAdd, x.weavingProcess)}
                                                            >
                                                            </Button>
                                                        </InputGroup>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <FormGroup id='noOfBags' label='No of Bags' isFloating>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, e.target.value, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.noOfBags || ''}
                                                                isValid={challanDetailsForm.isValid}
                                                                onBlur={challanDetailsForm.handleBlur}
                                                                placeholder="Enter No Of Bags" disabled />
                                                        </FormGroup>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <FormGroup id='quantity' label='Total Net Weight' isFloating>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, e.target.value, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.quantity || ''}
                                                                isValid={challanDetailsForm.isValid}
                                                                onBlur={challanDetailsForm.handleBlur}
                                                                placeholder="Enter Dispatch Date" disabled />
                                                        </FormGroup>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <FormGroup id='productRate' label='Rate' isFloating>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, e.target.value, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.productRate || ''}
                                                                onBlur={() => challanDetailsForm.setFieldTouched(`productRate_${index}`, true)}
                                                                isValid={(challanDetailsForm.touched as any)[`productRate_${index}`] ? !(challanDetailsForm.errors as any)[`productRate_${index}`] : undefined}
                                                                isTouched={(challanDetailsForm.touched as any)[`productRate_${index}`]}
                                                                invalidFeedback={(challanDetailsForm.errors as any)[`productRate_${index}`] as string}
                                                                placeholder="Enter Rate"
                                                                onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                        </FormGroup>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <FormGroup id='totalAmount' label='Amount' isFloating>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.totalAmount || ''}
                                                                isValid={challanDetailsForm.isValid}
                                                                onBlur={challanDetailsForm.handleBlur}
                                                                placeholder="Enter Amount"
                                                                disabled />
                                                        </FormGroup>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <InputGroup>
                                                            <InputGroupText className='bg-primary text-white'>CGST Rate</InputGroupText>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, x.productRate, e.target.value, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.cgstRate || ''}
                                                                onBlur={() => challanDetailsForm.setFieldTouched(`cgstRate_${index}`, true)}
                                                                isValid={(challanDetailsForm.touched as any)[`cgstRate_${index}`] ? !(challanDetailsForm.errors as any)[`cgstRate_${index}`] : undefined}
                                                                placeholder="CGST %"
                                                                onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                        </InputGroup>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <InputGroup>
                                                            <InputGroupText className='bg-primary text-white'>SGST Rate</InputGroupText>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, e.target.value, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.sgstRate || ''}
                                                                onBlur={() => challanDetailsForm.setFieldTouched(`sgstRate_${index}`, true)}
                                                                isValid={(challanDetailsForm.touched as any)[`sgstRate_${index}`] ? !(challanDetailsForm.errors as any)[`sgstRate_${index}`] : undefined}
                                                                placeholder="SGST %"
                                                                onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                        </InputGroup>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <InputGroup>
                                                            <InputGroupText className='bg-primary text-white'>CGST Amount</InputGroupText>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.cgstRate, e.target.value, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.cgstAmount || ''}
                                                                isValid={challanDetailsForm.isValid}
                                                                onBlur={challanDetailsForm.handleBlur}
                                                                placeholder="CGST Amount" disabled />
                                                        </InputGroup>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <InputGroup>
                                                            <InputGroupText className='bg-primary text-white'>SGST Amount</InputGroupText>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, e.target.value, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.sgstAmount || ''}
                                                                isValid={challanDetailsForm.isValid}
                                                                onBlur={challanDetailsForm.handleBlur}
                                                                placeholder="SGST Amount" disabled />
                                                        </InputGroup>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <FormGroup id='finalAmount' label='Total Amount' isFloating>
                                                            <Input
                                                                onChange={(e: any) => handleInputChange(x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.cgstRate, x.cgstAmount, x.sgstRate, x.sgstAmount, index, x.deliveryChallanDetailsId, x.isAdd, x.weavingProcess)}
                                                                value={x.finalAmount || ''}
                                                                isValid={challanDetailsForm.isValid}
                                                                onBlur={challanDetailsForm.handleBlur}
                                                                placeholder="Enter Total"
                                                                disabled />
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color='info'
                            isOutline
                            className='border-0'
                            onClick={closeAndReset}>
                            Close
                        </Button>
                        <Button color='info' type="submit" icon="Save" isDisable={!challanDetailsForm.isValid} onClick={challanDetailsForm.handleSubmit}>
                            Submit
                        </Button>
                    </ModalFooter>
                </Modal>
                <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />
            </Page>
        </PageWrapper >
    )
}

export default AddChallanDetails